import React from 'react';

import {BulkActionTool} from 'src/components/bulk-tool';
import {
    getAccountBulkChangeProgress,
    stopAccountBulkChange,
    userAccountBulkChange,
} from 'src/openapi/admin/apis/UserAccountBulkChangeApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    MODAL_WIDTH,
    TOOL_PROGRESS_LABEL,
    TOOL_STACK_OVERFLOW_MESSAGE,
    TOOL_TASK,
    TOOL_TITLE,
} from './constants';
import {UpdateUserAccountModal} from './update-user-account.modal';
import {
    selectUpdateUserAccountBulkUuid,
    selectUpdateUserAccountTask,
    setBackgroundTask,
    setShown,
    setUuid,
} from './update-user-account.slice';

import type {UsersAccountChangeRequest} from 'src/openapi/admin/models/UsersAccountChangeRequest';

type Props = {
    shown: boolean,
    userIds: number[],
    onDone: () => void,
    onClose: () => void,
};

export const UpdateUserAccountTool = ({shown, userIds, onDone, onClose}: Props) => {
    const apiDispatch = useAppDispatch();

    return (
        <BulkActionTool<UsersAccountChangeRequest>
            shown={shown}
            onClose={onClose}
            width={MODAL_WIDTH}

            toolTask={TOOL_TASK}
            toolName={TOOL_TITLE}
            progressLabel={TOOL_PROGRESS_LABEL}

            taskSelector={selectUpdateUserAccountTask}
            uuidSelector={selectUpdateUserAccountBulkUuid}

            setUuid={setUuid}
            setTask={setBackgroundTask}
            setResultShown={setShown}
            saveActionRequest={(usersAccountChangeRequest, options) => (
                apiDispatch(userAccountBulkChange({...options, usersAccountChangeRequest}))
            )}
            getProgress={id => apiDispatch(getAccountBulkChangeProgress({id}))}
            stopAction={id => apiDispatch(stopAccountBulkChange({id}))}

            stackOverflowMessage={TOOL_STACK_OVERFLOW_MESSAGE}
            onDone={onDone}>
            {({onCloseModal, processAction}) => (
                <UpdateUserAccountModal {...{userIds, onCloseModal, processAction}}/>
            )}
        </BulkActionTool>
    );
};
